import { render, staticRenderFns } from "./CreateStop.vue?vue&type=template&id=04f7e585&scoped=true&"
import script from "./CreateStop.vue?vue&type=script&lang=js&"
export * from "./CreateStop.vue?vue&type=script&lang=js&"
import style0 from "./CreateStop.vue?vue&type=style&index=0&id=04f7e585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7e585",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f7e585')) {
      api.createRecord('04f7e585', component.options)
    } else {
      api.reload('04f7e585', component.options)
    }
    module.hot.accept("./CreateStop.vue?vue&type=template&id=04f7e585&scoped=true&", function () {
      api.rerender('04f7e585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/components/CreateStop.vue"
export default component.exports